/**
 * 阿里iconfont配置
 **/
// 定义iconfont库
const iconfontVersion = ['2817661_ef5caufqa9l']
const iconfontUrlCss = `//at.alicdn.com/t/c/font_$key.css`
// 定义动态插入方法
export function loadStyle(url: string) {
  const link = document.createElement('link')
  link.type = 'text/css'
  link.rel = 'stylesheet'
  link.href = url
  const head = document.getElementsByTagName('head')[0]
  head.appendChild(link)
}

export function iconfontInit() {
  // 动态插入
  iconfontVersion.forEach((ele) => {
    loadStyle(iconfontUrlCss.replace('$key', ele))
  })
}
